export const alignItemLevel = () => {
    if (!window.obData || !window.obData.alignItems) {
        return;
    }
    const itemPageID = document.getElementById('page-type-identifier').dataset.itemId;
    if (window.obData && window.obData.alignItems) {
        const ccBlockObject = window.obData.alignItems;
        if (ccBlockObject) {
            const itemid = Object.keys(ccBlockObject);
            // if item ID is present and mentioned in the code block
            if (itemid.includes(itemPageID)) {
                const title = document.querySelector('article.entry-wrapper h1');
                if (title) {
                    title.style = `text-align: ${ccBlockObject[itemPageID]}`;
                }
            }
        }
    }

};

//GWL Code OB-7749 starts here
function scrollcta() {
    const item = document.querySelector('.single-page');
    if (item) {
        if (window.outerWidth >= 1351) {
            const cta = document.querySelector('.cta-item-container .tile.single.cta');
            if (cta) {
                if (window.scrollY === 0 || window.scrollY < 150) {
                    cta.classList.remove('scrolled');
                } else {
                    cta.classList.add('scrolled');
                }
                const footer = document.querySelector('.related-items-container') ? document.querySelector('.related-items-container') : document.getElementById("injected-footer");
                if (footer && cta) {
                    let top = document.querySelector('.entry-wrapper') ? document.querySelector('.entry-wrapper').clientHeight - 150 : 50;
                    top = Math.sign(top) > 0 ? top : 0;
                    if (window.scrollY > top) {
                        cta.classList.remove('scrolled');
                    }
                }
            }
        } else {
            const mobileCta = document.querySelector('.cta-item-container .tile.single.cta');
            if (mobileCta) {
                mobileCta.classList.remove('scrolled');
            }
        }
    }

}
//GWL Code OB-7749 end here
function CTAshift() {
    const embedDOM = document.querySelector('.single-embed-wrapper');
    const entryWrapper = document.querySelector('article.entry-wrapper');
    if (embedDOM && entryWrapper) {
        entryWrapper.insertAdjacentElement('beforebegin', embedDOM);
        if (embedDOM.querySelector('block-cta')) {
            entryWrapper.classList.add('gated-cta');
        }
    }
}

function ctaResize() {
    const ctaContainer = document.querySelector('.cta-item-container');
    const itemContainer = document.querySelector('.item-level.with-cta .item-data');
    if (ctaContainer && itemContainer) {
        itemContainer.insertAdjacentElement('afterend', ctaContainer);
    }
}
export { scrollcta, CTAshift, ctaResize };


// WEBPACK FOOTER //
// ./scriptPartials/alignItemLevel.js